import { Navigate, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Images, BedDouble, PenLine, UserCog, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { SiteLoader } from "../../components/site/Misc";

const NAV = [
  ["/admin", "Início", LayoutDashboard, "dashboard", true],
  ["/admin/fotos", "Galeria", Images, "photos"],
  ["/admin/acomodacoes", "Acomodações", BedDouble, "rooms"],
  ["/admin/conteudo", "Conteúdo", PenLine, "content"],
  ["/admin/conta", "Conta", UserCog, "account"],
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  if (user === null) return <SiteLoader />;
  if (!user) return <Navigate to="/admin/login" replace />;

  const doLogout = async () => {
    await logout();
    nav("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#000000] text-zinc-100" data-testid="admin-layout">
      <header className="sticky top-0 z-30 glass border-b border-[#D4AF37]/15">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
          <NavLink to="/admin" className="flex items-center gap-3" data-testid="admin-home-link">
            <img src="/img/logo-t.png" alt="Vienna Palace Hotel" className="h-9 w-auto" />
            <span className="font-caps text-[10px] text-zinc-500 hidden sm:inline">Painel</span>
          </NavLink>
          <div className="flex items-center gap-2">
            <a href="/" target="_blank" rel="noopener noreferrer" data-testid="admin-view-site-btn" className="h-11 px-4 inline-flex items-center gap-2 rounded-full border border-zinc-700 text-sm hover:border-[#D4AF37]">
              <ExternalLink size={16} /> <span className="hidden sm:inline">Ver site</span>
            </a>
            <button onClick={doLogout} data-testid="admin-logout-btn" className="h-11 px-4 inline-flex items-center gap-2 rounded-full border border-zinc-700 text-sm hover:border-red-400 hover:text-red-300">
              <LogOut size={16} /> <span className="hidden sm:inline">Sair</span>
            </button>
          </div>
        </div>
        <nav className="hidden md:block border-t border-zinc-900">
          <div className="max-w-6xl mx-auto px-6 flex gap-1">
            {NAV.map(([to, label, Icon, id, end]) => (
              <NavLink key={to} to={to} end={end} data-testid={`admin-nav-${id}`} className={({ isActive }) => `flex items-center gap-2 px-4 py-3 text-sm border-b-2 transition-colors ${isActive ? "border-[#D4AF37] text-[#E6C687]" : "border-transparent text-zinc-400 hover:text-zinc-100"}`}>
                <Icon size={16} /> {label}
              </NavLink>
            ))}
          </div>
        </nav>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 pb-32 md:pb-16">
        <Outlet />
      </main>
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-30 glass border-t border-[#D4AF37]/15 pb-[env(safe-area-inset-bottom)]">
        <div className="grid grid-cols-5">
          {NAV.map(([to, label, Icon, id, end]) => (
            <NavLink key={to} to={to} end={end} data-testid={`admin-mobile-nav-${id}`} className={({ isActive }) => `flex flex-col items-center justify-center gap-1 h-16 text-[10px] ${isActive ? "text-[#E6C687]" : "text-zinc-500"}`}>
              <Icon size={20} /> {label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
